import './index.scss';
import './components/contentblocks/Quots.scss';
import './components/contentblocks/ImageAndText.scss';
import './components/contentblocks/textblock.scss';
import './components/contentblocks/FullImageWidth.scss';
import './components/contentblocks/DocumentFiles.scss';

import Navigation from './components/navigation/navigation';
import Inquiry from './components/contentblocks/inquiry/Inquiry';
import Carousel from './components/contentblocks/carousel/carousel';
import Layer from './components/layer/Layer';

// import ExandController from './components/ExpandController';
// import SplashSign from './components/splash-sign/SplashSign';

new Inquiry();
new Carousel();
new Navigation();
new Layer();

// const s = new SplashSign();

// window.expand = ExandController;
// window.splashSign = s;


// WEBPACK FOOTER //
// ./src/index.js